import { Grid } from '@mui/material';
import {
  decodeURIComponentSafe,
  getWirCreatedReactiveScopeData,
} from 'pages/WellGuardian/WIR/utils';
import WgChip from 'pages/WellGuardian/WgChip';
import { useCountryState, useSelectedWIR } from '../../../../redux/WellGuardian/selectors';

import styles from './BasicHeaderWirCreateIntervention.module.scss';

const BasicHeaderWirCreateIntervention: React.FunctionComponent = () => {
  const wir = useSelectedWIR();
  const countryState = useCountryState();
  const { phase } = getWirCreatedReactiveScopeData(wir, countryState);

  return (
    <Grid direction="row" container className={styles.pageTitle}>
      <Grid direction="row">
        {wir?.wirNumber && (
          <WgChip
            variant="rounded"
            config={{
              text: wir?.wirNumber,
              className: styles.wirCaseNumber,
            }}
          />
        )}
      </Grid>
      <Grid direction="row">
        <h1>
          {decodeURIComponentSafe(
            wir?.phases?.[phase]?.sections?.initialRequestInformation?.interventionTitle ?? '',
          )}
        </h1>
      </Grid>
    </Grid>
  );
};

export default BasicHeaderWirCreateIntervention;
